export const EMAIL_DRAFT_ATTACHMENT_STORAGE_PREFIX = "email-draft-attachments";
export const MAX_EMAIL_DRAFT_ATTACHMENT_FILES = 5;
export const MAX_EMAIL_DRAFT_ATTACHMENT_BYTES = 18 * 1024 * 1024;
